<template>
  <div class="footer">
    <div class="w1200 footer_box">
      <div class="right">
        <p>关爱地球</p>
        <p>清洁能源</p>
        <p>源于中国</p>
        <p>服务全球</p>
        <!-- <p class="font16">鑫益电能官方服务热线</p>
        <div>
          <img src="../assets/phone.png" alt="" />
          <span class="font24 color38">0532-68002636</span>
        </div> -->
      </div>
      <div class="left">
        <div>地址：青岛市城阳区夏庄街道仙山东路28号A座六楼</div>
        <div>邮编：266109</div>
        <div>邮箱：xinyiservice@126.com</div>
        <div>传真：0532-68002637</div>
        <div>官方服务热线：0532-68002636</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "footermode",
  data() {
    return {};
  }
};
</script>
<style>
.footer {
  background: #f8fdff;
}
.footer .w1200 {
  padding: 70px 0 54px;
  background: url("../assets/foot.jpg") no-repeat;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.footer_box .left {
  font-size: 16px;
  /* color: #f1f1f1; */
}
.footer_box .left div {
  margin-bottom: 16px;
}
.footer_box .right {
  margin-top: -50px;
  font-size: 18px;
  width: 330px;
  padding: 12px 0 11px 0;
  line-height: 40px;
  /* border-left: 1px solid rgba(255, 255, 255, 0.1); */
}
.footer_box .right img {
  width: 24px;
  height: 24px;
  margin-right: 24px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue